import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import UserLayout from '../../layout/UserLayout';

import login from './login';
import register from './register';
import forgotPassword from './forgot-password';
import resetPassword from './reset-password';
import unsubscribe from './unsubscribe';
import booking from './booking';
import signup from './signup';
import vouchersignup from './vouchersignup';
import Invitations from './invitations';
import ForgotPin from './forgot-pin';
import ResetPin from './reset-pin';
const User = ({ match }) => {
  return (
    <UserLayout>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/login`} />
        <Route path={`${match.url}/login`} component={login} />
        <Route path={`${match.url}/register`} component={register} />
        <Route
          path={`${match.url}/forgot-password`}
          component={forgotPassword}
        />
        <Route path={`${match.url}/reset-password`} component={resetPassword} />
        <Route
          path={`${match.url}/forgot-pin`}
          component={ForgotPin}
        />
        <Route path={`${match.url}/reset-pin`} component={ResetPin} />
        <Route path={`${match.url}/unsubscribe`} component={unsubscribe} />
        <Route path={`${match.url}/booking`} component={booking} />
        <Route path={`${match.url}/signup`} component={signup} />
        <Route path={`${match.url}/invitations`} component={Invitations} />
        <Route path={`${match.url}/vouchersignup`} component={vouchersignup} />
        <Redirect to="/error" />
      </Switch>
    </UserLayout>
  );
};

export default User;
